import React, { useEffect } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Cog, FileCode2, Palette, Proportions, ShieldCheck } from 'lucide-react';

const WhatWeDo = () => {

   useEffect(() => {
      const details = gsap.utils.toArray(".whatwedo__content__item:not(:first-child)")
      const photos = gsap.utils.toArray(".whatwedo__thumb__content__item:not(:first-child)")

      gsap.set(photos, { yPercent: 101 })
      const allPhotos = gsap.utils.toArray(".whatwedo__thumb__item")

      // create
      let mm = gsap.matchMedia();
      mm.add("(min-width: 600px)", () => {
         ScrollTrigger.create({
            trigger: ".whatwedoSection",
            start: "top top",
            end: "bottom bottom",
            pin: ".whatwedothumb"
         })
         details.forEach((detail, index) => {
            let headline = detail.querySelector("h3")
            let animation = gsap.timeline()
               .to(photos[index], { yPercent: 0 })
               .set(allPhotos[index], { autoAlpha: 0 })
            ScrollTrigger.create({
               trigger: headline,
               start: "top 80%",
               end: "top 50%",
               animation: animation,
               scrub: true,
               markers: false
            })
         })

         return () => {};
      });

   }, [])


   return (
      <>
         <section className="whatwedoSection pt-40 pb-40 tw-overflow-hidden">
            <div className='whatwedo__area'>
               <div className="tw-container tw-mx-auto">
                  <div className='tw-flex tw-flex-wrap tw--mx-3'>
                     <div className='tw-w-full tw-px-3 lg:tw-w-1/2 tw-relative'>
                        <div className="whatwedothumb whatwedo__thumb">
                           <div className='whatwedo__thumb__content'>
                              <div className="whatwedo__thumb__content__item" style={{ background: `url(assets/img/offerings/software_dev.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                              <div className="whatwedo__thumb__content__item" style={{ background: `url(assets/img/offerings/CMS.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                              <div className="whatwedo__thumb__content__item" style={{ background: `url(assets/img/offerings/UIUX.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                              <div className="whatwedo__thumb__content__item" style={{ background: `url(assets/img/offerings/Testing.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                              <div className="whatwedo__thumb__content__item" style={{ background: `url(assets/img/offerings/ITSupport.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                           </div>
                        </div>
                     </div>

                     <div className='tw-w-full tw-px-3 lg:tw-w-1/2 tw-relative'>
                        <div className="whatwedo__content">
                           <div className="whatwedo__content__item">
                              <div className="section__title tw-flex section__title-3">
                                 <div className='section__title__icon mt-5'>
                                    <FileCode2 size="54" strokeWidth='1' />
                                 </div>
                                 <div className='section__title__content'>
                                    <span>What we do</span>
                                    <h3>Product Development</h3>
                                    <p className="mt-2">
                                       we specialize in transforming ideas into dynamic, user-centric websites, mobile apps, and robust backend systems. With cutting-edge technologies and a passion for innovation, we deliver tailored digital solutions that drive results across platforms.
                                    </p>
                                 </div>
                              </div>
                           </div>

                           <div className="whatwedo__content__item">
                              <div className="section__title tw-flex section__title-3">
                                 <div className='section__title__icon mt-5'>
                                    <Proportions size="54" strokeWidth='1' />
                                 </div>
                                 <div className='section__title__content'>
                                    <span>What we do</span>
                                    <h3>CMS Solutions</h3>
                                    <p className="mt-2">
                                       We understand that effective content management is essential for success in today's digital landscape. That's why we take a holistic approach to CMS solutions, focusing not only on functionality but also on usability, scalability, and performance.
                                    </p>
                                 </div>
                              </div>
                           </div>

                           <div className="whatwedo__content__item">
                              <div className="section__title tw-flex section__title-3">
                                 <div className='section__title__icon mt-5'>
                                    <Palette size="54" strokeWidth='1' />
                                 </div>
                                 <div className='section__title__content'>
                                    <span>What we do</span>
                                    <h3>UI/UX Design</h3>
                                    <p className="mt-2">
                                       We prioritize user needs and industry best practices through a process of research, collaboration, and iteration. From concept to execution, every design decision is crafted to resonate with your audience and drive results.</p>
                                 </div>
                              </div>
                           </div>

                           <div className="whatwedo__content__item">
                              <div className="section__title tw-flex section__title-3">
                                 <div className='section__title__icon mt-5'>
                                    <ShieldCheck size="54" strokeWidth='1' />
                                 </div>
                                 <div className='section__title__content'>
                                    <span>What we do</span>
                                    <h3>Software Testing</h3>
                                    <p className="mt-2">
                                       Delivering flawless software is non-negotiable in today’s competitive landscape. At Harsoft Solutions, we offer meticulous software testing services to ensure your applications are reliable, secure, and high-performing.</p>
                                 </div>
                              </div>
                           </div>

                           <div className="whatwedo__content__item">
                              <div className="section__title tw-flex section__title-3">
                                 <div className='section__title__icon mt-5'>
                                    <Cog size="54" strokeWidth='1' />
                                 </div>
                                 <div className='section__title__content'>
                                    <span>What we do</span>
                                    <h3>IT Support & Managed</h3>
                                    <p className="mt-2">
                                       We develop customized IT support plans to suit your unique business objectives. Whether you're a small startup or a large enterprise, our focus is on minimizing downtime, resolving issues efficiently, and enhancing performance so you can focus on growth.
                                    </p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>

         </section>
      </>
   );
};

export default WhatWeDo;
